import { defineStore } from 'pinia'
import { api } from '@/plugins/axios';

export const useDashboardStore = defineStore('dashboard-store', {
  // State (if you need to store any date-related state)
  state: () => ({
    loading: false,
    rows: [],
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 5,
    },    
  }),

  // Getters (computed properties)
  getters: {},

  // Actions (methods)
  actions: {
    async getRecentOrders(order_type, page = 1) {
      this.loading = true
      const limit = this.pagination.per_page // we want only 2 records per page

      let filterArray = []

      if (order_type === 'recent') {
        filterArray.push({
          column: 'order_process_status',
          condition: 'not_in',
          value: 'pickedup, delivered, cancel',
        })
      }

      let url = `/get-orders?page=${page}&limit=${limit}&joinWith=orderDetails.product.category&orderBy=created_at&orderType=DESC`
        
      if (filterArray.length) {
        url += '&filterArray=' + JSON.stringify(filterArray)
      }

      try {      
        const response = await api.get(url)
        const result = response.data.results

        this.rows = result.data || []
        this.pagination = {
          current_page: result.current_page,
          last_page: result.last_page,
          per_page: result.per_page,
        }
        this.loading = false
      } catch (error) {
        console.error(error)
        this.loading = false
      }
    }
  }
});
